/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

import { ParametresGeneraux } from '@/types';
import { validationAdresse, validationInformationsContact } from '..';

const validationTabCollectivite = (
  parametres: Partial<ParametresGeneraux>,
) => {
  const contactData = {
    tel1: parametres?.telephone1,
    mail: parametres?.adresseEmail
  };

  const contactErrors = validationInformationsContact(contactData, false);
  
  return _.pickBy({
    adresse: validationAdresse(parametres?.adresse, true)?.adresse,
    telephone1: contactErrors?.tel1,
    nomMaire: _.isEmpty(parametres?.nomMaire) ? 'Le nom du maire est obligatoire' : '',
    identifiantCiviliteMaire: _.isNil(parametres?.identifiantCiviliteMaire) || parametres?.identifiantCiviliteMaire === 0 
      ? 'La civilité du maire est obligatoire' 
      : '',
  }, v => !_.isNil(v) && !_.isEmpty(v));
};

export default validationTabCollectivite;